import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Center,
  ChakraProvider,
  Container,
  HStack,
  Spinner,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react';
import AdminHeader from '../components/AdminHeader';
import CaseStudyPreview from '../components/blog/CaseStudyPreview';
import { getBlog } from '../blog/blogApi';

function BlogPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [blog, setBlog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = 'Preview Case Study';
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getBlog(id);
        if (!cancelled) setBlog(data.blog);
      } catch (error) {
        if (!cancelled) {
          toast({
            description: error.message || 'Unable to load this case study.',
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'bottom',
          });
          if (/authentication/i.test(error.message || '')) {
            navigate('/Admin');
          }
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate, toast]);

  return (
    <ChakraProvider>
      <Box minH="100vh" bg="gray.50">
        <AdminHeader activeTab="blog" title="Case Study Preview" />
        <Container maxW="6xl" pb={10}>
          <HStack justify="space-between" mb={4} flexWrap="wrap" spacing={3}>
            <Button variant="ghost" onClick={() => navigate('/Admin/Blog')}>
              Back to Blog Management
            </Button>
            {blog && (
              <Button colorScheme="blue" onClick={() => navigate(`/Admin/Blog/edit/${blog.id}`)}>
                Edit
              </Button>
            )}
          </HStack>
          {isLoading ? (
            <Center py={20}>
              <VStack>
                <Spinner color="blue.500" />
                <Text>Loading preview...</Text>
              </VStack>
            </Center>
          ) : blog ? (
            <CaseStudyPreview
              blog={blog}
              notice={
                blog.status === 'published'
                  ? 'Admin preview of the saved case study. This screen is not the public website.'
                  : 'Admin preview of a draft. Unpublished drafts are not returned by the public case study API.'
              }
            />
          ) : (
            <Text color="gray.500">This case study could not be loaded.</Text>
          )}
        </Container>
      </Box>
    </ChakraProvider>
  );
}

export default BlogPreview;
